if ($('#modal-team-viewer').length) {
  if (!sessionStorage.getItem('modal-team-viewer')) {
    setTimeout(function () {
      sessionStorage.setItem('modal-team-viewer', true)
      $('.modal-team-viewer').css( "display", "block" )
    }, 3000)
  }
}

$(document).on('click', '.js-modalClose_team-viewer', function(event) {
  event.preventDefault();
  $('.modal-team-viewer').css( "display", "none" )
});
